<template>
    <div>
        <v-row>            
            <v-col sm="4">
                <br id="top"/>There are 5 rarities of weapon Enchantments:
                <ul>
                    <li><a @click="scrollTo('common')" >Common</a></li>
                    <li><a @click="scrollTo('rare')">Rare</a></li>
                    <li><a @click="scrollTo('epic')">Epic</a></li>
                    <li><a @click="scrollTo('legendary')">Legendary</a></li>              
                    <li><a @click="scrollTo('unique')">Unique</a></li>              
                </ul>
            </v-col>
            <v-col sm="4">
                <br/>6 Types:
                <ul>
                    <li>Melee</li>
                    <li>Ranged</li>
                    <li>Weapon (Melee and Ranged Weapons)</li>
                    <li>Armament</li>
                    <li>Rangement (Armaments and Ranged)</li>
                    <li>All</li>
                </ul>
            </v-col>
        </v-row>
        <br/><br/>
            <div v-for="rarity in rarities" :key="rarity">
                <h2 :id="rarity" style="color:cornflowerblue">{{rarity[0].toUpperCase() + rarity.substr(1)}} Enchantments:</h2>
                <table :style="`width:100%; border:2px solid ${getRarityColor(rarity)};`">
                    <tr> 
                        <th>Name</th>
                        <th>Type</th>
                        <th>Description</th>
                    </tr>
                    <tr v-for="enchant in sortedEnchantments(rarity)" :key="enchant.name"> 
                        <td style="text-align:center">{{enchant.name}}</td>
                        <td style="padding-left:4px; text-align:center; padding-right:4px">{{enchant.class}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{enchant.shortDesc}}</td>                        
                    </tr>
                </table>           
                <br/>
        </div> 
    </div>
</template>
<script>
//
import {weaponEnchantments} from "../../../play/data"

export default {
  components: {
  },
  props:{
  },
  mounted(){
        console.log("mounted")
        let section = document.getElementById("top")
        section.scrollIntoView()
  },
  data(){
      return{
          rarities:["common","rare","epic","legendary","unique"],
      }
  },
  methods:{
      sortedEnchantments(rarity){
        let allEnchants = [...weaponEnchantments]
        let sortedEnchants = allEnchants.filter(enchant=>enchant.rarity == rarity && enchant.class !="ammo")        
        let sorted = sortedEnchants.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        sorted = sorted.filter((value, index, self) =>
        index === self.findIndex((t) => (t.name === value.name)))
        return sorted
      },
      scrollTo(id){
        let section = document.getElementById(id)
        section.scrollIntoView({behavior: "smooth"})
      },
      getRarityColor(rarity){
        switch(rarity){
            case "common": return "black"
            case "rare": return "blue"
            case "epic": return "purple"
            case "legendary": return "orange"
            case "unique": return "red"
        }
      }
  }

}
</script>
<style scoped>
th, td {
  border:1px solid black;
}
</style>